import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { StudentTestsComponent } from '../../../../../shared/tables/student-tests/student-tests.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-daily-activities',
  standalone: true,
  imports: [CommonModule, StudentTestsComponent, TranslateModule],
  templateUrl: './daily-activities.component.html',
  styleUrl: './daily-activities.component.css',
})
export class DailyActivitiesComponent {}
